
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(198|294|812)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
